import { useState } from 'react';
import { X, Search, ArrowUpDown, ChevronDown } from 'lucide-react';

const exportTypes = [
  { codigo: '32', nombre: 'Dua Exportación EDI' },
  { codigo: '2048', nombre: 'Dua Recapitulativo de Exportación' },
  { codigo: '2', nombre: 'Dua Exportación Papel' },
];

export function getExportacionesTipos() {
  return exportTypes;
}

export const ExportacionesTipoModal = ({
  tipos = [],
  isOpen,
  onClose,
  onSelect,
  selectedTipo,
  title = 'Seleccionar Tipo de Exportación',
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [sortBy, setSortBy] = useState('name-asc');
  const [isSortOpen, setIsSortOpen] = useState(false);

  const sortOptions = [
    { value: 'name-asc', label: 'Nombre (A-Z)' },
    { value: 'name-desc', label: 'Nombre (Z-A)' },
    { value: 'code-asc', label: 'Código (asc)' },
    { value: 'code-desc', label: 'Código (desc)' },
  ];

  const filteredTipos = (tipos.length ? tipos : exportTypes).filter((tipo) =>
    tipo.nombre.toLowerCase().includes(searchQuery.toLowerCase()) ||
    tipo.codigo.includes(searchQuery)
  );

  const sortedTipos = [...filteredTipos].sort((a, b) => {
    switch (sortBy) {
      case 'name-asc':
        return a.nombre.localeCompare(b.nombre);
      case 'name-desc':
        return b.nombre.localeCompare(a.nombre);
      case 'code-asc':
        return a.codigo.localeCompare(b.codigo);
      case 'code-desc':
        return b.codigo.localeCompare(a.codigo);
      default:
        return 0;
    }
  });

  const getSortLabel = () => {
    return sortOptions.find((option) => option.value === sortBy)?.label || 'Ordenar por';
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{title}</h2>
          <button
            onClick={() => {
              setSearchQuery('');
              setIsSortOpen(false);
              onClose();
            }}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="flex gap-2 mb-4">
          {/* Search Input */}
          <div className="relative flex items-center gap-2 border-container rounded-full px-3 py-1 flex-1 flex-row">
            <div className="flex-0 pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="text"
              className="pr-4 py-2 !border-none no-border search-input"
              style={{ borderWidth: '0px !important', border: '0px !important' }}
              placeholder="Buscar tipo..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* Custom Sort Dropdown */}
          <div className="relative button-no-hover-effect text-sm">
            <button
              className="flex items-center gap-2 px-2 pr-0 py-2 rounded-full"
              onClick={() => setIsSortOpen(!isSortOpen)}
            >
              <ArrowUpDown className="w-4 h-4" />
              <span>{getSortLabel()}</span>
              <ChevronDown className={`w-4 h-4 transition-transform ${isSortOpen ? 'rotate-180' : ''}`} />
            </button>

            {isSortOpen && (
              <div className="overflow-hidden absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border-container py-1 z-10">
                {sortOptions.map((option) => (
                  <button
                    key={option.value}
                    className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${
                      sortBy === option.value ? 'text-primary' : 'text-gray-700'
                    }`}
                    onClick={() => {
                      setSortBy(option.value);
                      setIsSortOpen(false);
                    }}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="max-h-[60vh] min-h-[30vh] overflow-y-auto">
          {sortedTipos.length > 0 ? (
            <div className="space-y-0">
              {sortedTipos.map((tipo) => (
                <div
                  key={tipo.codigo}
                  className={`p-3 px-0 hover:bg-gray-100 cursor-pointer border-bottom-gray ${
                    selectedTipo && selectedTipo.codigo === tipo.codigo ? 'bg-gray-100 font-bold' : ''
                  }`}
                  onClick={() => {
                    onSelect(tipo);
                    setSearchQuery('');
                    setIsSortOpen(false);
                    onClose();
                  }}
                >
                  <div className="flex justify-between items-start gap-2">
                    <div>
                      <p className="font-medium">{tipo.nombre}</p>
                      <p className="text-xs text-gray-500">{tipo.codigo}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-4 text-gray-500">
              No se encontraron tipos para "{searchQuery}"
            </div>
          )}
        </div>
      </div>
    </div>
  );
}; 